import dayjs from "dayjs";
import Guid from "./Common/Guid";
import DeviceInfo from "./Common/DeviceInfo";
import Event from "./Common/Event"; // 事件绑定
import Util from "./Common/Util";
import CryptographyRsa from "./Cryptography/CryptographyRsa";
import CryptographyAes from "./Cryptography/CryptographyAes";
import Ajax from "./Ajax";

// 设备信息
class ClientSysInfo {
    constructor() {
        this.SysName = DeviceInfo.os.version;
        this.SysVer = DeviceInfo.os.digits;
        this.DeviceName = DeviceInfo.browser.browser;
        this.DeviceMaker = "";
        this.DeviceVer = DeviceInfo.browser.version;
        this.DeviceNumber = "";
    }
}

class SignalrReqHeader {
    /**
     * SignalR请求头
     */
    constructor() {
        this.Token = ""; // 令牌
        this.Host = ""; // 接口的Host
        this.ApiMethod = ""; // Api接口的方法
        this.TimeStamp = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS"); // 时间戳
        this.SystemCode = ""; // 当前系统编码，即发起请求的系统
        this.ClientSysInfo = new ClientSysInfo();
        this.GroupId = Guid.newGuid(); // 请求分组编号
        this.Sign = ""; // 签名
        this.SecretKey = Guid.newGuid().replace(/-/g, ""); // 密钥，限制长度32位
        this.RemoteIP = ""; // 远端IP地址，请求接口时由接口赋值
        this.Domain = ""; // 域名或主机名，请求接口时由接口赋值
        this.OperatorName = ""; // 操作人员名称，请求接口时由接口赋值
    }
}

/**
 * Signal 命令基本对象
 */
class SignalRCommandEntity {
    /**
     *
     * @param {SignalRCommands} command SignalR命令
     * @param {Int} commandVer SignalR命令版本号
     */
    constructor(command, commandVer) {
        this.TransId = Guid.newGuid(); // 单次发送的随机编号
        this.Command = command; // SignalR命令
        this.CommandVer = commandVer; // SignalR命令版本号
        this.CommandKey = this.Command + "_" + this.CommandVer; // 命令的唯一标识
        this.CreateTime = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS");
    }
}

const signalRDefines = {
    signalRConnectAuthorizeKey: "FA6DB906C7F04F848406FDD227102FD2",
    signalRConnectAuthorizeApiMethod: "F94113096BBC492783DC23A4F30BDA61",
};

class SignalR {
    #event = new Event();
    // 私有变量
    #signalRSecretKey = Guid.newGuid().replace(/-/g, "");
    // 命令内容加密Key
    #signalrCommandSecretKey = "";
    // 心跳定时Id
    #heartbeatInterval = 0;

    // 重新连接定时Id
    #reconnectionInterval = 0;
    // 已重连接次数
    #reconnectedCount = 0;
    // 是否是主动关闭链接
    #isActiveStopConnection = false;

    // 委托
    #delegate = {
        /**
         * Signalr状态变化
         * @param {Object} state 当前状态
         */
        stateChanged: (state) => {
            this.#event.emit("stateChanged", state);
        },
        /**
         * 收到服务端消息
         * @param {string} message 消息内容
         */
        receive: (message) => {
            this.#event.emit("receive", message);
        },
    };

    // 是否启用心跳
    isEnabledHeartbeat = true;
    // 心跳间隔时间 单位：秒
    heartbeatIntervalTime = 30;

    // 重连间隔时间 单位：秒
    reconnectionIntervalTime = 5;
    // 是否输出日志
    isLogging = true;
    // 版本号
    version = "1.0.2";

    /**
     *
     */
    constructor() {
        let _self = this;
        this.systemCode = "";
        this.connectUrl = "";
        this.connectAuthCode = "";
        this.userToken = "";
        this.rsaRemotePublicKey = "";
        this.userId = "";

        // 接收消息
        $.connection.signalRHub.client.OnReceive = (data) => {
            let cmdPlainText = data;
            if (data && data.Param) {
                cmdPlainText = CryptographyAes.decryptFormBase64(data.Param, this.#signalrCommandSecretKey);
            }
            this.#cwLog("收到消息：" + cmdPlainText);
            this.#delegate.receive(cmdPlainText);
        };

        // 开始
        $.connection.hub.starting(function () {
            _self.#cwLog("开始连接：");
        });

        // 连接错误
        $.connection.hub.error(function (error) {
            _self.#cwLog("监听到错误：" + error);
        });

        // 链接断开 state 4
        $.connection.hub.disconnected(function () {
            _self.#cwLog("链接断开");
            // https://docs.microsoft.com/zh-cn/aspnet/signalr/overview/guide-to-the-api/handling-connection-lifetime-events#how-to-continuously-reconnect
            // SocketTask关闭时默认清除心跳
        });

        // 正在重连
        $.connection.hub.reconnecting(function () {
            _self.#cwLog("正在重连");
        });

        // 已重新连接
        $.connection.hub.reconnected(function () {
            _self.#cwLog("已重新连接");
        });

        // 状态变更
        $.connection.hub.stateChanged(function (state) {
            _self.#cwLog("状态变更：" + JSON.stringify(state));
            _self.#delegate.stateChanged(state);
            if (state.newState === 1) {
                // 已连接，开启心跳
                _self.#startHeartbeat();
                // 清除重新连接次数
                _self.#reconnectedCount = 0;
                // 清除重新连接定时
                clearInterval(_self.#reconnectionInterval);
            } else if (state.oldState === 1 && state.newState === 4) {
                if (_self.#isActiveStopConnection == true) {
                    _self.#cwLog("主动断开链接，清除重连定时器");
                    // 主动断开链接
                    clearInterval(_self.#reconnectionInterval);
                } else {
                    // 断开重连
                    _self.#reconnection();
                }
            } else if (state.oldState === 2 && state.newState === 4) {
                // jquery.signalr已进行了重新连接并失败后，重新发起SignalR连接
                // 断开重连
                _self.#reconnection();
            } else if (state.newState !== 1) {
                // 已断开连接，清除心跳
                _self.#endHeartbeat();
            }
        });
    }

    /**
     * 输出 console.log
     * @param {*} message
     */
    #cwLog(message) {
        if (this.isLogging) {
            console.log(message);
        }
    }

    /**
     * 开始一个心跳
     */
    #startHeartbeat() {
        let _self = this;
        if (_self.isEnabledHeartbeat) {
            _self.#heartbeatInterval = setInterval(function () {
                _self.sendHeartbeat();
            }, _self.heartbeatIntervalTime * 1000);
        }
    }

    /**
     * 结束一个心跳
     */
    #endHeartbeat() {
        let _self = this;
        clearInterval(_self.#heartbeatInterval);
    }

    /**
     * 获取SignalR连接授权码
     */
    #getConnectionAuthCode() {
        let _self = this;
        return new Promise((resolve, reject) => {
            Ajax.threePlatformRequest(
                {
                    url: _self.signalrApiHost + "/api/SignalR/GetConnectionAuthCode",
                    data: {},
                    success: function (res) {
                        if (res.Code == 0) {
                            _self.connectAuthCode = res.Result;
                            resolve(res);
                        } else if (res.Code == -3) {
                            resolve(res);
                        } else {
                            reject("获取SignalR连接授权码失败：" + JSON.stringify(res));
                        }
                    },
                    error: function (err) {
                        reject(err);
                    },
                },
                _self.userToken,
                _self.systemCode,
                _self.rsaRemotePublicKey
            );
        });
    }

    /**
     * 重连
     */
    #reconnection() {
        let _self = this;
        clearInterval(_self.#reconnectionInterval);
        _self.#reconnectionInterval = setInterval(function () {
            _self.#reconnectedCount++;
            _self.#cwLog(`准备第${_self.#reconnectedCount}次重新连接`);
            _self.startConnection(_self.systemCode, _self.signalrApiHost, _self.connectUrl, _self.userToken, _self.userId, _self.rsaRemotePublicKey);
        }, _self.reconnectionIntervalTime * 1000);
    }

    /**
     * 绑定事件
     * @param {string} eventName 事件名称
     * @param {function} callback 回调方法
     */
    on(eventName, callback) {
        this.#event.on(eventName, callback);
    }

    /**
     * 解除事件绑定
     * @param {string} eventName 事件名称
     */
    off(eventName) {
        this.#event.off(eventName);
    }

    /**
     * 开始连接 SignalR
     * @param {string} systemCode 系统编码
     * @param {string} connectUrl 连接地址
     * @param {string} userToken 当前登录用户Token
     * @returns
     */
    startConnection(systemCode, signalrApiHost, connectUrl, userToken, userId, rsaRemotePublicKey) {
        let _self = this;
        this.systemCode = systemCode;
        this.signalrApiHost = signalrApiHost;
        this.connectUrl = connectUrl;
        this.userToken = userToken;
        this.rsaRemotePublicKey = rsaRemotePublicKey;
        this.userId = userId;

        this.#signalrCommandSecretKey = userId.replace(/-/g, "");
        this.#isActiveStopConnection = false;

        $.connection.hub.url = this.connectUrl;
        $.connection.hub.logging = false;

        this.#getConnectionAuthCode()
            .then((res) => {
                if (res.Code == 0) {
                    // 请求头加密
                    var reqHeader = new SignalrReqHeader();
                    reqHeader.SystemCode = systemCode;
                    reqHeader.Token = this.userToken;
                    reqHeader.ApiMethod = signalRDefines.signalRConnectAuthorizeApiMethod;
                    reqHeader.OperatorName = this.connectAuthCode;
                    reqHeader.SecretKey = this.#signalRSecretKey;

                    // 【02】设置请求头 REQ_HEADER_LPX_TOOLS
                    var reqHeaderEncryptBase64 = CryptographyRsa.encryptToBase64(JSON.stringify(reqHeader), rsaRemotePublicKey);

                    $.connection.hub.qs = {
                        [signalRDefines.signalRConnectAuthorizeKey]: reqHeaderEncryptBase64,
                    };
                    // 设置请求头，设置请求头后只能使用 longPolling（轮询）
                    // $.ajaxSetup({
                    //     headers: {
                    //         [signalRDefines.signalRConnectAuthorizeKey]: reqHeaderEncryptBase64
                    //     },
                    // });

                    // $.connection.hub.transport = $.connection.transports.webSockets;
                    // 开始链接signalr
                    $.connection.hub
                        //.start({ transport: ["webSockets", "longPolling", "serverSentEvents"] }) // webSockets、serverSentEvents、foreverFrame、longPolling
                        .start()
                        .done(function () {
                            // 连接成功
                            _self.#cwLog("连接成功事件");
                        })
                        .fail(function (error) {
                            // 连接失败，尝试重新连接
                            _self.#cwLog("Start连接失败" + error);
                            _self.#reconnection();
                        });
                } else if (res.Code == -3) {
                    // Token无效后不进行重新连接
                    clearInterval(_self.#reconnectionInterval);
                }
            })
            .catch((err) => {
                _self.#reconnection();
                console.error("连接授权码获取失败：" + err);
            });
    }

    /**
     * 停止 SignalR 连接
     */
    stopConnection() {
        this.#isActiveStopConnection = true;
        $.connection.hub.stop();
    }

    /**
     * 发送 SignalR 命令
     * @param {Object} signalRCommandEntity SignalR命令对象
     * @param {Function} sendResultFunc 发送结果回调
     */
    execCommand(serverMethodName, signalRCommandEntity, sendResultFunc) {
        let _self = this;

        // 发送结果
        let sendResult = {
            code: -1,
            codeMsg: "",
            data: {},
        };

        // signalR 必须为连接状态时才能发送
        if ($.connection.hub.state == 1) {
            let serverMethod = $.connection.signalRHub.server[serverMethodName];
            if (typeof serverMethod === "function") {
                let cmdCiphertext = CryptographyAes.encryptToBase64(JSON.stringify(signalRCommandEntity), _self.#signalrCommandSecretKey);

                // 发送消息
                let baseRsp = serverMethod({
                    OperatorName: "",
                    ReqId: Guid.newGuid(),
                    Param: cmdCiphertext,
                })
                    .then((res, n, r) => {
                        this.#cwLog("发送完成");
                        sendResult.code = 0;
                        sendResult.codeMsg = "发送成功";
                        if (res && res.Result) {
                            let cmdResPlainText = CryptographyAes.decryptFormBase64(res.Result, _self.#signalrCommandSecretKey);
                            sendResult.data = cmdResPlainText;
                        }

                        if (typeof sendResultFunc === "function") sendResultFunc(sendResult);
                    })
                    .catch((e) => {
                        sendResult.codeMsg = "发送消息异常，" + e;
                        if (typeof sendResultFunc === "function") sendResultFunc(sendResult);
                    })
                    .fail(() => {
                        sendResult.codeMsg = "发送消息失败";
                        if (typeof sendResultFunc === "function") sendResultFunc(sendResult);
                    })
                    .always(function () {});
            } else {
                sendResult.codeMsg = "未找到服务器方法" + serverMethodName;
                console.error(sendResult.codeMsg);
                if (typeof sendResultFunc === "function") sendResultFunc(sendResult);
            }
        } else {
            sendResult.codeMsg = "SignalR未连接";
            if (typeof sendResultFunc === "function") sendResultFunc(sendResult);
        }
    }

    /**
     * 发送心跳
     */
    sendHeartbeat() {
        var baseCommand = {};
        baseCommand.BusinessKey = "Heartbeat";
        baseCommand.BusinessContent = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS");
        this.execCommand("heartbeat", baseCommand);
    }

    /**
     * 给一个或多个用户发送消息
     * @param {Array} toUserIdList 接收人 UserId 列表
     * @param {String} businessKey 业务Key
     * @param {String} businessContent 业务内容
     * @param {Function} sendResultFunc 发送结果回调
     * @returns
     */
    sendToUser(toUserIdList, businessKey, businessContent, sendResultFunc) {
        //var baseCommand = new SignalRCommandEntity("SignalRCommands_SendToUser", 1);
        var baseCommand = {};
        baseCommand.ToUserIdList = toUserIdList;
        baseCommand.BusinessKey = businessKey;
        baseCommand.BusinessContent = businessContent;
        this.execCommand("sendToUser", baseCommand, sendResultFunc);
    }

    sendToUserByWebApi(toUserIdList, businessKey, businessContent, sendResultFunc) {
        let _self = this;
        // var baseCommand = new SignalRCommandEntity("SignalRCommands_SendToUser", 1);
        var baseCommand = {};
        baseCommand.ToUserIdList = toUserIdList;
        baseCommand.BusinessKey = businessKey;
        baseCommand.BusinessContent = businessContent;
        Ajax.threePlatformRequest(
            {
                url: _self.signalrApiHost + "/api/SignalR/SendToUser",
                data: baseCommand,
                success: function (res) {
                    console.log("sendToUserByWebApi发送成功");
                },
                error: function (err) {},
            },
            _self.userToken,
            _self.systemCode,
            _self.rsaRemotePublicKey
        );
    }

    /**
     * 收到服务端消息
     * @param {Function} callback 收到服务器端消息回调
     */
    onReceive(callback) {
        this.on("receive", callback);
    }

    /**
     * Signalr状态变化
     * @param {Function} callback 状态变化回调
     */
    onStateChanged(callback) {
        this.on("stateChanged", callback);
    }
}

window.YJY = window.YJY || {};
window.YJY.SignalR = (function () {
    let signalR = null;
    if (signalR == null) {
        signalR = new SignalR();
    }
    return signalR;
})();
